<!-- 资质荣誉 -->
<template>
    <div>
      <!-- <div class="header_img"></div> -->
       <sub-banner id="id_about">
        <img src="../../assets/images/honor/honor_banner.jpg"/>
      </sub-banner>

      <div class="honor_info">
          <div class="honor_content">
              <div class="honor_detail">
                  <div class="honor_item_img">
                      <div class="img_sd">
                          <img src="../../assets/images/honor/honor_one.png" />
                      </div>
                  </div>
                  <div class="honor_process_content">
                      <div class="process_title">
                          <div class="title_name">{{$t('honor.start')}}</div>
                          <div class="title_date">(2014-2017)</div>
                      </div>
                      <div class="process_content">
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">{{$t('honor.item_1')}}</div>
                          </div>
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                 {{$t('honor.item_2')}}
                              </div>
                          </div>
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                 {{$t('honor.item_3')}}
                              </div>
                          </div>
                          <div class="process_item">
                              <div class="cycle_out cycle_out_active">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                 {{$t('honor.item_4')}}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

               <div class="honor_detail">
                  
                  <div class="honor_process_contents">
                      <div class="process_title">
                          <div class="title_name">{{$t('honor.end')}}</div>
                          <div class="title_date">(2018-2021)</div>
                      </div>
                      <div class="process_content">
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">{{$t('honor.item_5')}}</div>
                          </div>
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                  {{$t('honor.item_6')}}
                              </div>
                          </div>
                          <div class="process_item">
                              <div class="cycle_out">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                 {{$t('honor.item_7')}}
                              </div>
                          </div>
                           <div class="process_item">
                              <div class="cycle_out cycle_out_active">
                                  <div class="cycle_in"></div>
                              </div>
                              <div class="process_c_info">
                                  {{$t('honor.item_8')}}
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="honor_item_img">
                      <div class="img_sd">
                          <img src="../../assets/images/honor/honor_two.png" />
                      </div>
                  </div>
              </div>
          </div>

          
      </div>
    </div>
</template>

<script>
import SubBanner from "@/components/sub-banner";
import Process from '../../components/process/process.vue';
export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-资质荣誉',
      metaName:'广州市熵达贸易有限公司-资质荣誉',
      metaContent:'广州市熵达贸易有限公司-资质荣誉',
      keyword:'广州市熵达贸易有限公司,',
      description:'广州市熵达贸易有限公司' ,   
      form: {
        code: '',
        name: '',
        phone: '',
        needContent:'',
      },
      verfyImg: process.env.BASE_URL + "customer/getVerifyCode",//图片验证码地址
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {

  },
  
  created () {

  },
  mounted () {
  },
}
</script>
<style lang='scss' scoped>
.honor_info{
    width:100%;
    background:#fff;
    .honor_content{
        width:70%;
        margin:auto;
        padding:170px 0px; 
        .honor_detail{
            display: flex;
            justify-content: space-between;
           align-items: center;
           margin-bottom:220px;
            .honor_item_img{
           margin-bottom:40px;
        //    margin-right:31px;
                .img_sd{

                }
            }
          &:last-child{
            
           margin-bottom:0px !important;
          }
        }
    }
}

.honor_process_content{
    // width:70%;
    // width:773px;
    text-align: center;
    .process_title{
        display:flex;
        justify-content: center;
        align-items: center;
        .title_name{
            font-size:22px;
            color:#333;
            font-weight:bold;
        }
        .title_date{
            font-size: 16px;
            color:#666666;
        }

    }
    .process_content{
        width:100%;
        display:flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: row;
        margin-top:63px;
        overflow: hidden;
        .process_item{
           
            position: relative;
            display: flex;
            align-items: center;
            justify-content:center;
            flex-direction: column;
            
            width:230px;
            padding-left:70px;
            .cycle_out{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 23px;
                height: 23px;
                border: solid 1px #b5b5b5;
                border-radius: 50%;
              .cycle_in{
                width: 14px;
                height: 14px;
                background-color: #b5b5b5;
                border-radius: 50%;
              }   
            }
            .cycle_out_active{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 23px;
                height: 23px;
                border: solid 1px #4f7cbd;
                border-radius: 50%;
                z-index: 9;
              .cycle_in{
                width: 14px;
                height: 14px;
                background-color: #4f7cbd;
                border-radius: 50%;
              }   
            }
            // .cycle_out:after{
            //     content:" ";
            //     position:absolute;
            //     left:20px;
            //     top:10px;
            //     bottom:0;
            //     width:100%;
            //     height:2px;
            //     transform:scaleY(.5);
            //     background-color:#b5b5b5;
            // }
            
            .process_c_info{
                margin-top:40px;
                font-size: 14px;
                color:#000000;
                text-align: left;
            }
            // &:first-child{
            //     margin-left:31px  !important; 
            // }
        }
        .process_item:after{
                content:" ";
                position:absolute;
                left:60%;
                top:10px;
                bottom:0;
                width:100%;
                height:2px;
                transform:scaleY(.5);
                background-color:#b5b5b5;
        }
        .process_item:last-child:after{
                content:" ";
                position:absolute;
                left:20px;
                top:10px;
                bottom:0;
                width:0;
                height:0px;
                transform:scaleY(.5);
                background-color:red;
        }
        
    }
}

.honor_process_contents{
    // width:70%;
    // width:773px;
    text-align: center;
    
    margin-right:20px;
    .process_title{
        display:flex;
        justify-content: center;
        align-items: center;
        .title_name{
            font-size:22px;
            color:#333;
            font-weight:bold;
        }
        .title_date{
            font-size: 16px;
            color:#666666;
        }

    }
    .process_content{
        width:100%;
        display:flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: row;
        margin-top:63px;
        .process_item{
           
            position: relative;
            display: flex;
            align-items: center;
            justify-content:center;
            flex-direction: column;
            
            width:210px;
            padding-left:70px;
            .cycle_out{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 23px;
                height: 23px;
                border: solid 1px #b5b5b5;
                border-radius: 50%;
              .cycle_in{
                width: 14px;
                height: 14px;
                background-color: #b5b5b5;
                border-radius: 50%;
              }   
            }
            .cycle_out_active{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 23px;
                height: 23px;
                border: solid 1px #4f7cbd;
                border-radius: 50%;
                z-index: 9;
              .cycle_in{
                width: 14px;
                height: 14px;
                background-color: #4f7cbd;
                border-radius: 50%;
              }   
            }
            // .cycle_out:after{
            //     content:" ";
            //     position:absolute;
            //     left:20px;
            //     top:10px;
            //     bottom:0;
            //     width:100%;
            //     height:2px;
            //     transform:scaleY(.5);
            //     background-color:#b5b5b5;
            // }
            
            .process_c_info{
                margin-top:40px;
                font-size: 14px;
                color:#000000;
                text-align: left;
            }
            &:first-child{
                padding-left:31px  !important; 
            }
        }
        .process_item:after{
                content:" ";
                position:absolute;
                left:60%;
                top:10px;
                bottom:0;
                width:100%;
                height:2px;
                transform:scaleY(.5);
                background-color:#b5b5b5;
        }
        .process_item:last-child:after{
                content:" ";
                position:absolute;
                left:20px;
                top:10px;
                bottom:0;
                width:0;
                height:0px;
                transform:scaleY(.5);
                background-color:red;
        }
        
    }
}

</style>
<style>

</style>


// WEBPACK FOOTER //
// src/view/honor/index.vue